import scheduleRows from '../actions/actionCreators/scheduleRows';
import scheduleConversations from '../actions/scheduleConversations';
import scheduleItems from '../actions/scheduleItems';
import { userMailInteractionAction } from 'owa-mail-actions';
import { getStore } from 'owa-mail-list-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { orchestrator } from 'satcheljs';

orchestrator(scheduleRows, actionMessage => {
    const { rowKeys, actionSource, scheduleReturnTime, tableViewId } = actionMessage;
    const tableView = getStore().tableViews.get(tableViewId);

    // Users cannot snooze search results so it's fine to pass null as instrumentationContexts
    userMailInteractionAction('Snooze', null /* instrumentationContexts */, {
        rowKeys,
    });

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            scheduleConversations(rowKeys, tableView, actionSource, scheduleReturnTime);
            return;

        case ReactListViewType.Message:
            scheduleItems(rowKeys, tableView, actionSource, scheduleReturnTime);
            return;

        default:
            throw new Error('scheduleRows: Invalid listView type');
    }
});
